import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import type { DownloadProps } from '../../Downloads/Download';
import useAudioPlayer from './hooks/useAudioPlayer';

import './style.scss';

export type AudioPlayerProps = Omit<DownloadProps, 'materialIconName' | 'target'>;

const AudioPlayer: React.FC<AudioPlayerProps> = ({ source, title, className }) => {
  const { t } = useTranslation();
  const {
    audioRef,
    progressRef,
    playing,
    setPlaying,
    togglePlayback,
    handleTimeUpdate,
  } = useAudioPlayer();

  const classes = c('AudioPlayer', className, {
    'AudioPlayer--playing': playing === true,
    'AudioPlayer--paused': playing === false,
  });

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <audio
        ref={audioRef}
        src={source}
        onTimeUpdate={handleTimeUpdate}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
      />
      <button
        className={classes}
        title={t(playing ? 'pause' : 'play')}
        type="button"
        onClick={togglePlayback}
      >
        <div className="AudioPlayer__icon">
          <span className="AudioPlayer__icon_wrapper">
            <Icon name={playing ? 'pause' : 'play_arrow'} flair="outlined" />
          </span>
        </div>

        <div className="AudioPlayer__content">
          <div className="AudioPlayer__title">{title}</div>
          <div className="AudioPlayer__progress">
            <div
              ref={progressRef}
              className="AudioPlayer__progress_bar"
            />
          </div>
        </div>
      </button>
    </>
  );
};

export default AudioPlayer;
